import * as Sentry from "@sentry/browser";
import type { ErrorEvent, EventHint } from "@sentry/types";

import { updateSentryEvent } from "@formant/core/common/sentryUtils";
import { ITags } from "@formant/core/model/ITags";

export function setupSentry(
    dsn: string,
    options: Sentry.BrowserOptions = {},
    tags: ITags = {},
) {
    Sentry.init({
        dsn,
        beforeSend: (event: ErrorEvent, _hint: EventHint) => {
            // updateSentryEvent expects Event type, but beforeSend receives ErrorEvent
            // ErrorEvent extends Event, so we can safely cast
            const updatedEvent = updateSentryEvent(event as any);
            return updatedEvent as ErrorEvent | null;
        },
        integrations: integrations =>
            integrations.filter(_ => _.name !== "GlobalHandlers"),
        maxValueLength: 10000,
        ...options,
    });

    const scope = Sentry.getCurrentScope();
    Object.entries(tags).forEach(([key, value]) => scope.setTag(key, value));
}
